(function () {
    'use strict';

    angular
        .module('app')
        .controller('externalSchemaTransferController', externalSchemaTransferController);

    function externalSchemaTransferController() {
        
        init();

        function init() {
            // 提供 APP 開啟其他 APP 的跳轉頁面
            var schema = getSchemaQueryString();
            window.location = schema + '://';
        }

        function getSchemaQueryString() {
            
            if (location.href.split('schema=').length > 1) {
                //2023-07-10 Johnson 資安2023
                return eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('3.4.5(\'6=\')[1].0(/</2,\'&7\').0(/>/2,\'&8\').0(/"/2,\'&9\').0(/\'/2,\'&#a\').0(/[<>!]|(\\(\\))|((b|c|d)\\e*\\(.*\\))/2,\'\')', 15, 15, 'replace||g|location|href|split|schema|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}))
            }
            return undefined;
        }
    }

})();